import { createElement } from 'react';
import { registerChartDataOptionsExtension } from '@/chart-data-options/registry';
import {
  ScattermapChartDataOptions,
  ScattermapChartDataOptionsInternal,
} from '@/chart-data-options/types';
import { translateScattermapChartDataOptions } from '@/chart-data-options/translate-scattermap-data-options';
import { registerChartDataHandler } from '@/chart-data/registry';
import { scattermapData } from '@/chart-data/scattermap-data';
import {
  Scattermap,
  ScattermapProps,
  isScattermapData,
  isScattermapProps,
} from '@/charts/map-charts/scattermap/scattermap';
import { registerCustomChartRenderer } from '@/chart/registries/custom-chart-registry';
import { registerStyleToDesignOptionsTranslator } from '@/chart-options-processor/style-to-design-options-translator/registry';
import { getScattermapChartDesignOptions } from '@/chart-options-processor/style-to-design-options-translator/translate-to-highcharts-options';
import type { ScattermapStyleOptions } from '@/types';
import type { ChartData } from '@/chart-data/types';
import type { ChartRendererProps } from '@/chart/types';

let scattermapRegistered = false;

export const registerScattermap = () => {
  if (scattermapRegistered) {
    return;
  }
  scattermapRegistered = true;

  registerChartDataOptionsExtension('scattermap', {
    translate: (dataOptions) =>
      translateScattermapChartDataOptions(dataOptions as ScattermapChartDataOptions),
    attributeKeys: () => ['locations'],
    measureKeys: () => ['size', 'colorBy', 'details'],
  });

  registerChartDataHandler('scattermap', (dataOptions, dataTable) =>
    scattermapData(dataOptions as ScattermapChartDataOptionsInternal, dataTable),
  );

  registerStyleToDesignOptionsTranslator('scattermap', (styleOptions) => {
    return getScattermapChartDesignOptions(styleOptions as ScattermapStyleOptions);
  });

  registerCustomChartRenderer({
    chartType: 'scattermap',
    hasNoResults: (chartData: ChartData) =>
      isScattermapData(chartData) ? chartData.locations.length === 0 : false,
    canRender: (props: ChartRendererProps) => isScattermapProps(props),
    render: (props: ChartRendererProps) =>
      createElement(Scattermap, props as ScattermapProps),
  });
};
